export default {"src":"/_next/static/media/Teams.f2bbac9e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};